import { useIntlayer } from 'react-intlayer';

import { Button } from '~/components/ui/button';
import { FadeIn } from '~/components/ui/fade-in';
import { ArrowUpRight } from '~/components/ui/icons';
import { ImageBackground } from '~/components/ui/image-background';
import { SOCIAL_LINKS } from '~/constants';
import { openExternal } from '~/utils/open-external';

export const CTASection = () => {
  const { ctaSection } = useIntlayer('landing');

  return (
    <section className="relative h-[600px]">
      <div className="absolute inset-0 h-[600px]">
        <ImageBackground
          imageUrl="/assets/images/TrypillianStills_5.1.1.png"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-[rgba(0,0,0,0.4)]" />
      </div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="flex flex-col gap-[28px] items-center text-center text-white px-[16px]">
          <FadeIn>
            <div className="flex flex-col gap-[12px] items-center">
              <p className="font-fragment-mono text-xs tracking-[0.12px] uppercase">
                {ctaSection.subtitle}
              </p>
              <div className="font-manrope font-medium text-[32px] lg:text-4xl leading-[1.2] tracking-[0.32px] lg:tracking-[0.48px] w-full lg:w-[606px]">
                <p>{ctaSection.title.line1}</p>
                <p>{ctaSection.title.line2}</p>
              </div>
            </div>
          </FadeIn>
          <FadeIn delay={0.15}>
            <Button
              onClick={(e) => {
                e.preventDefault();
                openExternal(SOCIAL_LINKS.LINKEDIN);
              }}
              variant="default"
              className="px-[24px] py-[10px] text-base"
            >
              {ctaSection.button}
              <ArrowUpRight className="size-[16px]" />
            </Button>
          </FadeIn>
        </div>
      </div>
    </section>
  );
};
